export const XHR_LOADING_STATE = 'LOADING';
export const XHR_SUCCESS_STATE = 'SUCCESS';
export const XHR_FAILED_STATE = 'FAILED';
export const XHR_UPDATED_STATE = 'UPDATED';
